export const ACTIVE_STATUS = "A";
export const INACTIVE_STATUS = "I";
export const CUSTOM_BUTTON_TYPE = "custom_button";
export const CONSTITUENTS_FILE_TYPE = "constituents_list";
export const INDEX_HISTORY_CSV_FILE_TYPE = "index_history";